import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CSSModules from "lib/utils/css-modules";

import {
  Link,
  Feed,
  Label,
  Button,
  st,
  SubBar,
  MainView,
  BillRow,
  OrderStatusLabel,
  BalanceStatusLabel,
  EditButton,
  FormControl,
  Form,
  OrderCustomerLink,
  OrderAutomationModeIcon,
  UsersRepository,
} from "lib/index";
import { open as openAddOrderTransferModal } from "modules/orders/AddOrderTransferModal";
import AddOrderTransferModal from "modules/orders/AddOrderTransferModal/AddOrderTransferModal";
import { open as openEditOrderCustomerDetailsModal } from "modules/orders/EditOrderCustomerDetailsModal";
import EditOrderCustomerDetailsModal from "modules/orders/EditOrderCustomerDetailsModal/EditOrderCustomerDetailsModal";
import { open as openEditOrderNotesModal } from "modules/orders/EditOrderNotesModal";
import EditOrderNotesModal from "modules/orders/EditOrderNotesModal/EditOrderNotesModal";
import { open as openEditOrderInstallmentsModal } from "modules/orders/EditOrderInstallmentsModal";
import EditOrderInstallmentsModal from "modules/orders/EditOrderInstallmentsModal/EditOrderInstallmentsModal";
import { open as openEditOrderItemsModal } from "modules/orders/EditOrderItemsModal";
import EditOrderItemsModal from "modules/orders/EditOrderItemsModal/EditOrderItemsModal";
import { open as openFinishOrderModal } from "modules/orders/FinishOrderModal";
import FinishOrderModal from "modules/orders/FinishOrderModal/FinishOrderModal";
import { open as openChangeOrderScheduleSlotModal } from "modules/orders/ChangeOrderScheduleSlotModal";
import ChangeOrderScheduleSlotModal from "modules/orders/ChangeOrderScheduleSlotModal/ChangeOrderScheduleSlotModal";
import OrderSidebarPreview from "lib/components/OrderSidebarPreview";
import {
  confirmOrder,
  approveOrderWithConfirm,
  rejectOrderWithConfirm,
  finishOrderWithConfirm,
  finishOrderWithCallback,
  cancelOrderWithConfirm,
  deleteOrderWithConfirm,
  redoOrder,
  redeliverCustomerOrderEmail,
  redeliverCustomerOrderOpinionReminderEmail,
  redeliverSupplierOrderEmail,
} from "modules/orders/utils";
import { stateSelector, initializeView, fetchOrder, loadOrder, showLoader } from "./index";
import styles from "./ShowOrderView.less";
import openChangeOrderStatusPrompt from "./ChangeOrderStatusPrompt";
import { goToOrder, processPayment } from "modules/orders/utils";
import { StripeRepository } from "lib/repositories/index";

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
    currentCompany: state.auth.company.model,
    order: stateSelector(state).order.model,
    fetchDone: stateSelector(state).order.fetchDone,
    fetchLoading: stateSelector(state).order.fetchLoading,
    fetchFailed: stateSelector(state).order.fetchFailed,
    actionPending: state.orders.utils.orderActionPendingById[stateSelector(state).orderId || null] === true,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        showLoader,
        fetchOrder,
        loadOrder,
        confirmOrder,
        approveOrderWithConfirm,
        rejectOrderWithConfirm,
        finishOrderWithConfirm,
        cancelOrderWithConfirm,
        deleteOrderWithConfirm,
        finishOrderWithCallback,
        redoOrder,
        redeliverCustomerOrderEmail,
        redeliverCustomerOrderOpinionReminderEmail,
        redeliverSupplierOrderEmail,
        openAddOrderTransferModal,
        openEditOrderCustomerDetailsModal,
        openEditOrderNotesModal,
        openEditOrderInstallmentsModal,
        openEditOrderItemsModal,
        openChangeOrderScheduleSlotModal,
        openFinishOrderModal,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class ShowOrderView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView(+this.props.params.id, this.props.params.token);
    this.getUsers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.props.initializeView(+nextProps.params.id, nextProps.params.token);
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }
  subscriptions = [];
  getUsers() {
    const sub = UsersRepository.getAll().subscribe((users) => {
      let filteredUsers = [];
      if (users) {
        users.map((u) => {
          filteredUsers.push({ id: u.id, full_name: u.admin_user.full_name });
        });
      }

      this.setState({ users: filteredUsers });
    });
    this.subscriptions.push(sub);
  }
  getUserFullNameById = (id) => {
    if (this.state && this.state.users && this.state.users.length) {
      const _user = this.state.users.filter((u) => u.id === id)[0];
      if (_user) {
        return _user.full_name;
      } else {
        return null;
      }
    }
    return null;
  };

  handleChangeOrderStatusClick() {
    const { order, loadOrder, redeliverCustomerOrderOpinionReminderEmail } = this.props;
    openChangeOrderStatusPrompt({
      order,
      redeliverCustomerOrderOpinionReminderEmail,
    }).then((order) => {
      if (order) {
        loadOrder(order);
      }
    });
  }

  handleCancelOrderClick() {
    this.props.cancelOrderWithConfirm(this.props.order);
  }

  handleDeleteOrderClick() {
    this.props.deleteOrderWithConfirm(this.props.order);
  }

  handleNewOrderTransferClick() {
    const { order, currentCompanyId } = this.props;
    const isAgent = order.agent && order.agent.id === currentCompanyId;
    this.props.openAddOrderTransferModal({
      order,
      transfer: {
        sender: "customer",
        receiver: isAgent ? "agent" : "supplier",
      },
    });
  }

  handleNewOrderRefundClick() {
    const { order, currentCompanyId } = this.props;
    const isAgent = order.agent && order.agent.id === currentCompanyId;
    this.props.openAddOrderTransferModal({
      order,
      transfer: {
        sender: isAgent ? "agent" : "supplier",
        receiver: "customer",
      },
    });
  }

  gotoPayment() {
    const { order } = this.props;

    StripeRepository.paymentOperations(order.id, order.token, order, 0);
    this.props.showLoader();
  }

  isStripePaymentPossible() {
    if (this.props.order.remaining_total_amount_sum && this.props.order.remaining_total_amount_sum.length > 0) {
      const arr = this.props.order.remaining_total_amount_sum;

      for (const o of arr) {
        if (o.currency === "PLN" && o.value > 2) {
          return true;
        }
        if (o.currency === "EUR" && o.value > 0.5) {
          return true;
        }
        if (o.currency === "USD" && o.value > 0.5) {
          return true;
        }
        if (o.currency === "GBP" && o.value > 0.3) {
          return true;
        }
      }
    }
    return false;
  }
  isStripeDisabled() {
    return !this.isStripePaymentPossible();
  }
  renderSectionMainActions() {
    const { order, currentCompany } = this.props;

    const canChangeStatus = order.canCallAction("change_status") && st.authorize("change_status", order);

    return (
      <div styleName="section--main-actions">
        {order.product_type !== "coupon" && (
          <Button
            as="a"
            size="small"
            color="blue"
            disabled={this.isStripeDisabled()}
            style={{ marginBottom: "5px" }}
            content={I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_reseller")}
            onClick={this.gotoPayment.bind(this)}
          />
        )}{" "}
        &nbsp;
        {!currentCompany.reseller && order.has_pricing && (
          <Button
            as="a"
            size="small"
            color="blue"
            content={I18n.t("papp.orders.ShowOrderView.add_new_transfer")}
            onClick={this.handleNewOrderTransferClick.bind(this)}
          />
        )}
        &nbsp;
        {!currentCompany.reseller && order.has_pricing && (
          <Button
            as="a"
            size="small"
            color="blue"
            content={I18n.t("papp.orders.ShowOrderView.add_new_refund")}
            onClick={this.handleNewOrderRefundClick.bind(this)}
          />
        )}
        &nbsp;
        <Button
          as="a"
          size="small"
          color="blue"
          content={I18n.t("papp.orders.ShowOrderView.edit_note")}
          onClick={() => this.props.openEditOrderNotesModal(order)}
        />
        &nbsp;
        {canChangeStatus && (
          <Button
            as="a"
            size="small"
            color="blue"
            content={I18n.t("papp.orders.ShowOrderView.change_status")}
            onClick={this.handleChangeOrderStatusClick.bind(this)}
          />
        )}
        &nbsp;
        <Button
          as="a"
          size="small"
          color="blue"
          href={order.customer_pdf_voucher_url}
          target="_blank"
          content={I18n.t("papp.orders.ShowOrderView.print")}
        />
      </div>
    );
  }

  renderSectionCustomerDetails() {
    const { order, currentCompanyId } = this.props;
    const receptionist = this.getUserFullNameById(order.assigned_creator_id);

    return (
      <div styleName="section--customer-details">
        <div styleName="section-title">
          <OrderCustomerLink
            order={order}
            currentCompanyId={currentCompanyId}
            placeholder={I18n.t("papp.orders.ShowOrderView.customer_title")}
          />
          &nbsp;
          <EditButton onClick={this.props.openEditOrderCustomerDetailsModal.bind(null, order)} />
        </div>
        <div styleName="customer-metas">
          <div styleName="customer-metas-left">
            {order.persons_count > 0 && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">people</i>
                  <span className="text">{I18n.t("base.x_persons", { count: order.persons_count })}</span>
                  &nbsp;
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.openEditOrderCustomerDetailsModal(order);
                    }}
                  >
                    {I18n.t("papp.orders.ShowOrderView.see_details")}
                  </a>
                </span>
              </div>
            )}
            {order.customer_phone_number && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">phone</i>
                  <span className="text">{order.customer_phone_number}</span>
                </span>
              </div>
            )}
            {order.customer_email && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">email</i>
                  <span className="text">{order.customer_email}</span>
                </span>
                &nbsp;&nbsp;
                {st.authorize("notify_customer", order) && (
                  <a
                    href="#"
                    className={this.props.actionPending ? "u-disabledLink" : undefined}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.redeliverCustomerOrderEmail(order);
                    }}
                  >
                    {I18n.t("papp.orders.ShowOrderView.send_notification")}
                  </a>
                )}
                &nbsp;&nbsp;
                {st.authorize("notify_customer", order) && order.status === "finished" && (
                  <a
                    href="#"
                    className={this.props.actionPending ? "u-disabledLink" : undefined}
                    onClick={(e) => {
                      e.preventDefault();

                      this.props.redeliverCustomerOrderOpinionReminderEmail(order);
                    }}
                  >
                    {I18n.t("papp.orders.ShowOrderView.send_opinion_reminder_notification")}
                  </a>
                )}
              </div>
            )}
            {order.customer_locale && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">g_translate</i>
                  <span className="text">{order.customer_locale}</span>
                </span>
              </div>
            )}
            {order.coupon_code_name && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">label_outline</i>
                  <span className="text">
                    {I18n.humanAttributeName("order", "coupon_code_name")}: {order.coupon_code_name}
                  </span>
                </span>
              </div>
            )}
          </div>
          <div styleName="customer-metas-right">
            {(order.company.id !== currentCompanyId || order.supplier_id === currentCompanyId) && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">account_balance</i>
                  <span className="text">
                    {I18n.humanAttributeName("order", "supplier")}: {order.company.name}
                  </span>
                </span>
                &nbsp;&nbsp;
                {st.authorize("notify_supplier", order) && (
                  <a
                    href="#"
                    className={this.props.actionPending ? "u-disabledLink" : undefined}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.redeliverSupplierOrderEmail(order);
                    }}
                  >
                    {I18n.t("papp.orders.ShowOrderView.send_notification")}
                  </a>
                )}
              </div>
            )}

            {order.agent && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">share</i>
                  <span className="text">
                    {I18n.humanAttributeName("order", "agent")}: {order.agent.name}
                  </span>
                </span>
              </div>
            )}

            {order.affiliate && (st.authorize("read_affiliate", order) || st.authorize.company.reseller) && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">transfer_within_a_station</i>
                  <span className="text">
                    {I18n.humanAttributeName("order", "affiliate")}: {order.affiliate.name}
                  </span>
                </span>
              </div>
            )}

            {receptionist && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">local_mall</i>
                  <span className="text">
                    {I18n.humanAttributeName("order", "receptionist")}: {receptionist}
                  </span>
                </span>
              </div>
            )}

            <div styleName="customer-meta">
              <span className="with-icon">
                <i className="icon material-icons">surround_sound</i>
                <span className="text">
                  {I18n.humanAttributeName("order", "author_place")}: {order.author_place_formatted}
                </span>
              </span>
            </div>

            {order.manual && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <OrderAutomationModeIcon automatic={!order.manual} />
                  <span className="text">{I18n.humanAttributeName("order", "manual")}</span>
                </span>
              </div>
            )}

            {!order.manual && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <OrderAutomationModeIcon automatic={!order.manual} />
                  <span className="text">{I18n.humanAttributeName("order", "automatic")}</span>
                </span>
              </div>
            )}
          </div>
        </div>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
          }}
        >
          {order.customer_note && (
            <FormControl.TextAreaFormGroup
              value={order.customer_note}
              label={I18n.humanAttributeName("order", "customer_note")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}
          {order.additional_information && (
            <FormControl.TextAreaFormGroup
              value={order.additional_information}
              label={I18n.humanAttributeName("order", "additional_information")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}
          {order.internal_note && (
            <FormControl.TextAreaFormGroup
              value={order.internal_note}
              label={I18n.humanAttributeName("order", "internal_note")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}
          {order.supplier_note && st.authorize("update_supplier_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.supplier_note}
              label={I18n.humanAttributeName("order", "supplier_note")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}
          {order.agent_note && st.authorize("update_agent_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.agent_note}
              label={I18n.humanAttributeName("order", "agent_note")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}
          {order.st_note && st.authorize("update_st_note", order) && (
            <FormControl.TextAreaFormGroup
              value={order.st_note}
              label={I18n.humanAttributeName("order", "st_note")}
              autoHeight
              readOnly
              className="u-inputWithoutBorder"
            />
          )}

          <button type="submit" hidden />
        </Form>
      </div>
    );
  }

  renderSectionBill() {
    const { order, openEditOrderItemsModal } = this.props;
    return (
      <div styleName="section">
        <table className="ui table celled very basic clear unstackable">
          <thead>
            <tr className="u-trStrongBorderBottom">
              <th>
                <div styleName="table-title">
                  {I18n.t("papp.orders.ShowOrderView.order_items_title")} { }
                  {!st.authorize.company.reseller && (
                    <EditButton
                      onClick={openEditOrderItemsModal.bind(null, order)}
                    />
                  )}
                </div>
              </th>
              <th className="right aligned bottom aligned collapsing">
                {I18n.t("papp.orders.ShowOrderView.order_item_unit_price")}
              </th>
              <th className="center aligned bottom aligned collapsing">
                {I18n.t("papp.orders.ShowOrderView.order_item_quantity")}
              </th>
              <th className="right aligned bottom aligned collapsing">{I18n.t("papp.common.in_total")}</th>
            </tr>
          </thead>
          <tbody>
            {order.order_items.map((item) => (
              <BillRow
                key={item.uuid}
                name={item.name}
                quantity={item.quantity}
                unitPrice={st.formatMoney(item.unit_price)}
                totalPrice={st.formatMoney(item.total_price)}
              />
            ))}
          </tbody>
          <tfoot className="full-width">
            <BillRow
              className="u-trStrongBorderTop"
              summary
              name={I18n.t("fe.order_details.total_amount")}
              totalPrice={st.formatMoney(order.total_amount_sum)}
            />
          </tfoot>
        </table>
      </div>
    );
  }

  renderSectionPayments() {
    const { order } = this.props;
    return (
      <div styleName="section">
        <table className="ui table celled very basic clear unstackable">
          <thead>
            <tr className="u-trStrongBorderBottom">
              <th>
                <div className="u-flexRow">
                  <div styleName="table-title">{I18n.t("papp.orders.ShowOrderView.payments_title")}</div>
                  &nbsp;
                  <BalanceStatusLabel status={order.balance_status} />
                  &nbsp;
                  {!st.authorize.company.reseller && (
                    <div>
                      <a className="c-LinkButton" onClick={this.handleNewOrderTransferClick.bind(this)}>
                        <i className="icon material-icons">add</i>
                        {I18n.t("papp.orders.ShowOrderView.add_new_transfer")}
                      </a>
                      &nbsp;
                      <a className="c-LinkButton" onClick={this.handleNewOrderRefundClick.bind(this)}>
                        <i className="icon material-icons">add</i>
                        {I18n.t("papp.orders.ShowOrderView.add_new_refund")}
                      </a>
                    </div>
                  )}
                </div>
                <div styleName="section-subtitle">
                  {order.payment_profile_name
                    ? `${I18n.humanAttributeName("order", "payment_profile")}: ${order.payment_profile_name}`
                    : I18n.humanAttributeName("order", "payment_profile")}
                  {order.payment_profile_id && st.authorize.member.st_admin
                    ? ` (#${order.payment_profile_id})`
                    : undefined}
                  &nbsp;
                  {!st.authorize.company.reseller && (
                    <EditButton onClick={this.props.openEditOrderInstallmentsModal.bind(null, order)} size="normal" />
                  )}
                </div>
              </th>
              <th className="right aligned bottom aligned collapsing">{I18n.t("papp.common.in_total")}</th>
            </tr>
          </thead>
          <tbody>
            {order.order_transfers
              .filter((t) => t.includes_customer)
              .map((transfer) => (
                <tr key={transfer.id}>
                  <td>
                    <div className="u-flexRow">
                      <BalanceStatusLabel status="fully_paid" onlyIcon />
                      &nbsp;
                      {transfer.name}
                    </div>
                  </td>
                  <td className="right aligned collapsing u-whiteSpaceNowrap">
                    {st.formatMoney(transfer.amount)}
                    {transfer.transaction_amount && transfer.transaction_amount_differs && (
                      <span className="color-disabled"> ({st.formatMoney(transfer.transaction_amount)})</span>
                    )}
                  </td>
                </tr>
              ))}
            {!order.withdrawn &&
              order.installments
                .filter((ins) => ins.balance_status !== "fully_paid")
                .map((installment) => (
                  <tr key={installment.id}>
                    <td>
                      <div className="u-flexRow">
                        <BalanceStatusLabel status={installment.balance_status} onlyIcon />
                        &nbsp;
                        {installment.name}
                      </div>
                    </td>
                    <td className="right aligned collapsing u-whiteSpaceNowrap">
                      {st.formatMoney(installment.remaining_paid_amount_sum)}
                    </td>
                  </tr>
                ))}
          </tbody>
          <tfoot className="full-width">
            {!order.withdrawn &&
              !!(
                order.remaining_total_amount_sum &&
                order.remaining_total_amount_sum.length > 0
              ) ? (
              <tr className="u-trStrongBorderTop">
                <th className="summary">
                  {I18n.t("fe.order_details.remaining_total_amount")}
                </th>
                <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                  {st.formatMoney(order.remaining_total_amount_sum)}
                </th>
              </tr>
            ) : (
              <tr className="u-trStrongBorderTop">
                <th className="summary" />
                <th className="summary" />
              </tr>
            )}
            {!!(
              order.overpaid_total_amount_sum &&
              order.overpaid_total_amount_sum.length > 0
            ) && (
                <tr>
                  <th className="summary">
                    {I18n.t("fe.order_details.overpaid_total_amount")}
                  </th>
                  <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                    {st.formatMoney(order.overpaid_total_amount_sum)}
                  </th>
                </tr>
              )}
          </tfoot>
        </table>
      </div>
    );
  }

  renderSectionAgent() {
    const { order, openEditOrderItemsModal } = this.props;
    return (
      order.agent &&
      !st.authorize.company.reseller && (
        <div styleName="section">
          <table className="ui table celled very basic clear unstackable">
            <thead>
              <tr className="u-trStrongBorderBottom">
                <th>
                  <div styleName="table-title">
                    {I18n.t("papp.orders.ShowOrderView.agent_title")}{" "}
                    <EditButton onClick={openEditOrderItemsModal.bind(null, order)} />
                  </div>
                </th>
                <th className="right aligned bottom aligned collapsing">{I18n.t("papp.common.in_total")}</th>
              </tr>
            </thead>
            <tbody>
              {order.agent_service_fee_amount && (
                <tr>
                  <td>{I18n.humanAttributeName("order", "agent_service_fee")}</td>
                  <td className="right aligned collapsing u-whiteSpaceNowrap">
                    {order.agent_service_fee_amount ? st.formatMoney(order.agent_service_fee_amount) : "-"}
                  </td>
                </tr>
              )}
              <tr>
                <td>{I18n.humanAttributeName("order", "agent_commision")}</td>
                <td className="right aligned collapsing u-whiteSpaceNowrap">
                  {order.agent_commision_amount ? st.formatMoney(order.agent_commision_amount) : "-"}
                </td>
              </tr>
              {order.affiliate && st.authorize("read_affiliate", order) && (
                <tr>
                  <td>{I18n.humanAttributeName("order", "affiliate_commision")}</td>
                  <td className="right aligned collapsing u-whiteSpaceNowrap">
                    {order.affiliate_commision_amount ? st.formatMoney(order.affiliate_commision_amount) : "-"}
                  </td>
                </tr>
              )}
              {order.order_transfers
                .filter((t) => t.includes_agent)
                .map((transfer, i) => (
                  <tr key={transfer.id} className={i === 0 ? "u-trStrongBorderTop" : null}>
                    <td>
                      {transfer.name}
                      {transfer.agent_disbursement_id && (
                        <Link
                          to={`/c/${st.authorize.company.id
                            }/finances?agent_disbursement_id=${transfer.agent_disbursement_id
                            }`}
                        >
                          {" "}
                          ({I18n.t("attributes.agent_disbursement")} #{transfer.agent_disbursement_id})
                        </Link>
                      )}
                    </td>
                    <td className="right aligned collapsing u-whiteSpaceNowrap">
                      {st.formatMoney(transfer.amount)}
                      {transfer.transaction_amount && transfer.transaction_amount_differs && (
                        <span className="color-disabled"> ({st.formatMoney(transfer.transaction_amount)})</span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot className="full-width">
              {(order.agent_remaining_received_amount_sum.length > 0 ||
                order.agent_remaining_paid_amount_sum.length === 0) && (
                  <tr className="u-trStrongBorderTop">
                    <th className="summary">{I18n.humanAttributeName("order", "agent_remaining_received_amount")}</th>
                    <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                      {order.agent_remaining_received_amount_sum.length > 0
                        ? st.formatMoney(order.agent_remaining_received_amount_sum)
                        : st.formatMoney({
                          value: 0,
                          currency: order.agent_commision_amount.currency,
                        })}
                    </th>
                  </tr>
                )}
              {order.agent_remaining_paid_amount_sum.length > 0 && (
                <tr>
                  <th className="summary">{I18n.humanAttributeName("order", "agent_remaining_paid_amount")}</th>
                  <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                    {order.agent_remaining_paid_amount_sum.length > 0
                      ? st.formatMoney(order.agent_remaining_paid_amount_sum)
                      : "-"}
                  </th>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      )
    );
  }

  // Money between the supplier and Tripsomnia: the platform fee the order carries and every
  // transfer settling it - the manual settlement in both directions, and the automatic
  // Stripe payouts to the supplier. None of those belong to the customer or the agent
  // group, so without this section they do not show on the order at all.
  renderSectionPlatform() {
    const { order } = this.props;
    const transfers = order.order_transfers.filter((t) => t.includes_socialtravel);
    const settled =
      order.socialtravel_remaining_received_amount_sum.length === 0 &&
      order.socialtravel_remaining_paid_amount_sum.length === 0;

    return (
      // Marketplace orders are settled with the Agent, where Tripsomnia is the agent, and
      // the section above already shows them.
      !order.marketplace &&
      !st.authorize.company.reseller && (
        <div styleName="section">
          <table className="ui table celled very basic clear unstackable">
            <thead>
              <tr className="u-trStrongBorderBottom">
                <th>
                  <div className="u-flexRow">
                    <div styleName="table-title">{I18n.t("papp.orders.ShowOrderView.platform_title")}</div>
                    &nbsp;
                    {order.platform_disbursement_status && (
                      <Label color={order.platform_disbursement_status === "cleared" ? "green" : "grey"}>
                        {I18n.humanAttributeName("order", order.platform_disbursement_status)}
                      </Label>
                    )}
                  </div>
                </th>
                <th className="right aligned bottom aligned collapsing">{I18n.t("papp.common.in_total")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{I18n.t("papp.orders.ShowOrderView.platform_fee")}</td>
                <td className="right aligned collapsing u-whiteSpaceNowrap">
                  {order.saas_commision_amount ? st.formatMoney(order.saas_commision_amount) : "-"}
                </td>
              </tr>
              {transfers.map((transfer, i) => (
                <tr key={transfer.id} className={i === 0 ? "u-trStrongBorderTop" : null}>
                  <td>{transfer.name}</td>
                  <td className="right aligned collapsing u-whiteSpaceNowrap">
                    {st.formatMoney(transfer.amount)}
                    {transfer.transaction_amount && transfer.transaction_amount_differs && (
                      <span className="color-disabled"> ({st.formatMoney(transfer.transaction_amount)})</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className="full-width">
              {(order.socialtravel_remaining_received_amount_sum.length > 0 || settled) && (
                <tr className="u-trStrongBorderTop">
                  <th className="summary">
                    {I18n.humanAttributeName("order", "socialtravel_remaining_received_amount")}
                  </th>
                  <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                    {settled
                      ? st.formatMoney({
                        value: 0,
                        currency: order.saas_commision_amount
                          ? order.saas_commision_amount.currency
                          : order.product_price_currency,
                      })
                      : st.formatMoney(order.socialtravel_remaining_received_amount_sum)}
                  </th>
                </tr>
              )}
              {order.socialtravel_remaining_paid_amount_sum.length > 0 && (
                <tr>
                  <th className="summary">{I18n.humanAttributeName("order", "socialtravel_remaining_paid_amount")}</th>
                  <th className="right aligned summary collapsing u-whiteSpaceNowrap">
                    {st.formatMoney(order.socialtravel_remaining_paid_amount_sum)}
                  </th>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      )
    );
  }

  renderSectionHistory() {
    const { order } = this.props;
    return (
      <div styleName="section--history">
        <div styleName="section-title">{I18n.t("papp.orders.ShowOrderView.activities_title")}</div>

        <Feed
          events={order.activities.map((activity) => {
            let icon, meta;
            if (["Activity::EmailSent"].includes(activity.type)) {
              icon = <i className="icon material-icons">email</i>;
            } else if (["Activity::SmsSent", "Activity::SmsSendFailed"].includes(activity.type)) {
              icon = <i className="icon material-icons">smartphone</i>;
            } else if (["Activity::OrderStatusUpdated"].includes(activity.type)) {
              icon = <i className="icon material-icons">track_changes</i>;
            } else if (["Activity::OrderTransferCreated"].includes(activity.type)) {
              icon = <i className="icon material-icons">monetization_on</i>;
            } else if (["Activity::PaymentOperationStatusUpdated"].includes(activity.type)) {
              icon = <i className="icon material-icons">attach_money</i>;
            } else if (["Activity::ReviewCreated"].includes(activity.type)) {
              icon = <i className="icon material-icons">chat</i>;
            }

            if (activity.admin_user) {
              meta = (
                <div className="metas">
                  <div className="meta">
                    <a>
                      <i className="icon material-icons">person_outline</i> {activity.admin_user.email}
                    </a>
                  </div>
                </div>
              );
            }

            return {
              key: activity.id,
              date: st.formatTime(activity.created_at, { localZone: true }),
              summary: activity.title,
              content: activity.content,
              icon: <div className="label">{icon}</div>,
              meta,
            };
          })}
        />
      </div>
    );
  }

  renderSubBar() {
    const { order, fetchDone, actionPending } = this.props;
    const canChangeStatus = order && order.canCallAction("change_status") && st.authorize("change_status", order);

    return (
      <SubBar>
        <div style={{ marginRight: '2px' }} className="pull-left u-flexRow">
          <h1>
            {I18n.t("papp.orders.ShowOrderView.title", {
              order_id: this.props.params.id,
            })}
          </h1>
          &nbsp;
          {fetchDone && <OrderAutomationModeIcon automatic={!order.manual} style={{ fontSize: "1.4em" }} />}
          &nbsp;
          {fetchDone && (
            <OrderStatusLabel
              status={order.status}
              onClick={canChangeStatus ? this.handleChangeOrderStatusClick.bind(this) : undefined}
              className={canChangeStatus ? "u-cursorPointer" : undefined}
            />
          )}
        </div>
        {
          fetchDone &&
          <div>
            {order.connectly_order !== undefined &&
              <span>
                <Label color="yellow">
                  {`${order.connectly_order.connectly_source.name} ${order.connectly_order.source_order_id}`}
                </Label>
                {order.connectly_order.is_canceled &&
                  <span styleName='canceled-order-circle'>
                    <Label empty circular />
                  </span>
                }
              </span>
            }
          </div>
        }
        {fetchDone && (
          <div className="pull-right">
            {order.canCallAction("approve") && st.authorize("approve", order) && (
              <span>
                <Label color="yellow" pointing="right">
                  {order.pauses_at
                    ? I18n.t("papp.orders.ShowOrderView.approve_until_warning", {
                      date: st.formatTime(order.pauses_at, {
                        localZone: true,
                      }),
                    })
                    : I18n.t("papp.orders.ShowOrderView.approve_warning")}
                </Label>
                &nbsp;
                <Button
                  as="a"
                  color="red"
                  onClick={this.props.rejectOrderWithConfirm.bind(null, order)}
                  disabled={actionPending}
                  content={I18n.t("papp.order.reject")}
                />
                &nbsp;
                <Button
                  as="a"
                  color="green"
                  onClick={this.props.approveOrderWithConfirm.bind(null, order)}
                  disabled={actionPending}
                  content={I18n.t("papp.order.approve")}
                />
              </span>
            )}

            {order.canCallAction("confirm") && st.authorize("confirm", order) && (
              <span>
                <Button
                  as="a"
                  secondary
                  primary
                  onClick={this.props.confirmOrder.bind(null, order)}
                  disabled={actionPending}
                  content={I18n.t("papp.order.confirm")}
                />
              </span>
            )}
          </div>
        )}
      </SubBar>
    );
  }

  render() {
    const isStripeable = true;

    const {
      order,
      fetchDone,
      fetchLoading,
      fetchFailed,
      actionPending,
      loadOrder,
      fetchOrder,
      openChangeOrderScheduleSlotModal,
      openFinishOrderModal,
      finishOrderWithCallback,
    } = this.props;

    return (
      <div styleName="mainview-container">
        <MainView.Container>
          {this.renderSubBar()}
          <MainView.Content hasSubBar>
            <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchOrder} />

            {fetchDone && (
              <div styleName="content">
                <div styleName="main">
                  {this.renderSectionMainActions()}
                  {this.renderSectionCustomerDetails()}

                  {order.product_type !== "coupon" && this.renderSectionBill()}
                  {order.product_type !== "coupon" && this.renderSectionPayments()}
                  {order.product_type !== "coupon" && this.renderSectionAgent()}
                  {order.product_type !== "coupon" && this.renderSectionPlatform()}
                  {this.renderSectionHistory()}
                </div>

                <div styleName="sidebar">
                  <OrderSidebarPreview
                    order={order}
                    extended={false}
                    onScheduleSlotEditClick={() => openChangeOrderScheduleSlotModal(order)}
                  />

                  {order.canCallAction("finish") && st.authorize("finish", order) && (
                    <div className="u-marginTop u-overflowHidden">
                      <Button
                        as="a"
                        size="small"
                        secondary
                        basic
                        floated="right"
                        onClick={this.props.openFinishOrderModal.bind(null, order)}
                        disabled={this.props.actionPending}
                        content={I18n.t("papp.order.finish_order")}
                      />
                    </div>
                  )}

                  <div className="u-marginTop u-overflowHidden">
                    {order.canCallAction("cancel") && st.authorize("cancel", order) && (
                      <Button
                        as="a"
                        basic
                        negative
                        floated="right"
                        disabled={actionPending}
                        onClick={this.handleCancelOrderClick.bind(this)}
                        content={I18n.t("papp.order.cancel_order")}
                      />
                    )}

                    {order.canCallAction("destroy") && st.authorize("destroy", order) && (
                      <Button
                        as="a"
                        basic
                        negative
                        floated="right"
                        className="u-marginRight"
                        disabled={actionPending}
                        onClick={this.handleDeleteOrderClick.bind(this)}
                        content={I18n.t("papp.order.delete_order")}
                      />
                    )}
                  </div>
                </div>

                <FinishOrderModal
                  order={order}
                  onSave={loadOrder}
                  finishOrder={finishOrderWithCallback.bind(this, {
                    ...order,
                    status: "finished",
                  })}
                />
                <EditOrderCustomerDetailsModal onSave={loadOrder} />
                <EditOrderNotesModal onSave={loadOrder} />
                <EditOrderInstallmentsModal onSave={loadOrder} />
                <AddOrderTransferModal onSave={loadOrder} />
                <EditOrderItemsModal onSave={loadOrder} />
                <ChangeOrderScheduleSlotModal />
              </div>
            )}
          </MainView.Content>
        </MainView.Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/ShowOrderView/ShowOrderView.jsx